module.exports = __webpack_public_path__ + "static/img/14010105.288bc869.png";